export const whatsNew_FlexPane_Title = "mCa";
export default {whatsNew_FlexPane_Title};